import Dot from '@/components/ui/Dot.tsx';
import { ClientAcceptanceVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import ClientAcceptanceNotePanel from './ClientAcceptanceNotePanel.tsx';
import {
  acceptancePackageHeading,
  acceptancePackageMetaLabel,
} from './clientAcceptanceCopy.ts';

interface ClientAcceptanceOperatorPanelProps
  extends React.HTMLAttributes<HTMLDivElement> {
  view: ClientAcceptanceVm;
}

/** Co wysyłka paczki zmienia u organizatora, zanim klient zdecyduje. */
const ClientAcceptanceOperatorPanel = ({
  view,
  ...props
}: ClientAcceptanceOperatorPanelProps) => (
  <ClientAcceptanceNotePanel
    title="Co widzi organizator"
    contentClassName="gap-3.5 pt-4"
    {...props}
  >
    <div className="flex items-center gap-2.5 rounded-[10px] border border-accent-border-strong bg-accent-100 px-3 py-[11px]">
      <Dot size="lg" />
      <span className="min-w-0">
        <span className="block text-sm font-bold text-accent-900">
          {acceptancePackageHeading(view.bookingCode)}
        </span>
        <span className="mt-0.5 block text-[13px] text-accent-900">
          {acceptancePackageMetaLabel(view.sentAt, view.groups, view.balance)}
        </span>
      </span>
    </div>
    <p className="text-pretty text-sm leading-normal text-neutral-600">
      Taka belka zastępuje pasek szkicu na ekranie rezerwacji i wchodzi na
      miejsce pozycji szkicu w panelu bocznym. Rezerwacja dalej działa na
      wartościach sprzed zmian, a edycja jest zablokowana do czasu decyzji
      zapisującego.
    </p>
  </ClientAcceptanceNotePanel>
);

export default ClientAcceptanceOperatorPanel;
